/*
 * Wide screens show the app at the size it has on a 1080p screen (owner, 2026-11-03: "make pc the same size as on 1080, my
 * 1440 makes it alot smaller"). The page is zoomed by its width over 1920, from 1 up to 1.5, so phones, laptops and 1080p
 * screens are untouched and a 1440p screen gets 1.33. It reads the window's outside width, which Chrome zoom does not
 * change, so Ctrl plus and minus still grow or shrink the app on top of this (owner, 2026-11-03: "make my 1440 the exact
 * same size as the one on my 2nd computer"; innerWidth shrank with Chrome zoom and cancelled it out).
 *
 * Zoom also grows vh and vw, so the styles use var(--vh, 1vh) and var(--vw, 1vw), which hold one unit at the zoomed
 * size. Screen numbers (clientX, getBoundingClientRect, innerWidth) are not zoomed; turn them into style pixels with
 * unzoom() before setting left, top, width or height.
 */
const BASE_WIDTH = 1920;
const MAX_ZOOM = 1.5;

let zoom = 1;

/** Screen pixels as style pixels on the zoomed page. */
export function unzoom(n: number): number {
  return n / zoom;
}

function fit(): void {
  const root = document.documentElement;
  zoom = Math.min(MAX_ZOOM, Math.max(1, Math.round((window.outerWidth / BASE_WIDTH) * 100) / 100));
  if (zoom === 1) {
    for (const p of ["zoom", "--vh", "--vw"]) root.style.removeProperty(p);
    return;
  }
  root.style.setProperty("zoom", String(zoom));
  root.style.setProperty("--vh", `${window.innerHeight / 100 / zoom}px`);
  root.style.setProperty("--vw", `${window.innerWidth / 100 / zoom}px`);
}

export function fitWideScreens(): void {
  fit();
  window.addEventListener("resize", fit);
}
